module.exports = __webpack_public_path__ + "img/66.b7e07f3c.jpg";